import { AuthService } from '../services/auth.js';
import { CONFIG } from '../config.js';
import { showToast, getAlerceLogo } from '../components/ui.js';

export function renderLoginView() {
  return `
    <div class="min-h-[100dvh] flex items-center justify-center p-4 bg-background animate-fade-in">
      <div class="max-w-sm w-full bg-surface p-8 rounded-md border border-border shadow-card space-y-6">
        <div class="text-center space-y-1.5">
          <div class="flex justify-center mb-3">
            ${getAlerceLogo('w-12 h-12 shadow-sm')}
          </div>
          <h1 class="text-xl font-bold tracking-tight text-text-primary">EQUIPO ALERCE BUSINESS OS</h1>
          <p class="text-xs text-text-secondary">Ingreso exclusivo para el operador del sistema</p>
        </div>

        <form id="form-login" class="space-y-4">
          <div>
            <label class="block text-xs font-semibold text-text-primary mb-1">Correo Electrónico</label>
            <input 
              type="email" 
              id="login-email" 
              value="${CONFIG.OWNER_EMAIL}"
              class="w-full text-xs font-mono border border-border rounded-md px-3 py-2 bg-surface text-text-primary focus:ring-2 focus:ring-primary outline-none" 
              required 
            />
          </div>

          <div>
            <label class="block text-xs font-semibold text-text-primary mb-1">Contraseña</label>
            <input 
              type="password" 
              id="login-password" 
              placeholder="••••••••" 
              class="w-full text-xs font-mono border border-border rounded-md px-3 py-2 bg-surface text-text-primary focus:ring-2 focus:ring-primary outline-none" 
              required 
            />
          </div>

          <div id="login-error" class="text-xs text-red-600 bg-red-50 p-2.5 rounded border border-red-200 hidden font-medium"></div>

          <button 
            type="submit" 
            id="btn-submit-login" 
            class="w-full py-2.5 text-xs font-semibold rounded-md bg-primary text-white hover:bg-primary-hover active:bg-primary-active transition-all shadow-sm"
          >
            Iniciar Sesión
          </button>
        </form>

        <div class="pt-4 border-t border-border/60 text-center">
          <span class="text-[10px] font-mono text-text-secondary">
            v${CONFIG.VERSION} • Desplegado en Cloudflare Pages
          </span>
        </div>
      </div>
    </div>
  `;
}

export function initLoginEvents() {
  const form = document.getElementById('form-login');
  const errorEl = document.getElementById('login-error');
  const submitBtn = document.getElementById('btn-submit-login');

  if (form) {
    form.onsubmit = async (e) => {
      e.preventDefault();
      const email = document.getElementById('login-email').value;
      const password = document.getElementById('login-password').value;

      errorEl.classList.add('hidden');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Verificando...';

      try {
        await AuthService.signIn(email, password);
        showToast('Bienvenido a Business OS');
        window.location.hash = '#/dashboard';
      } catch (err) {
        errorEl.textContent = `Error de autenticación: ${err.message || 'Credenciales inválidas'}`;
        errorEl.classList.remove('hidden');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Iniciar Sesión';
      }
    };
  }
}
